'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { RadiusPixel, Sizes, Spacing } from '../../constants';
export const ProfileButton = (_a) => {
    var { children, selected, size = Sizes.base } = _a, props = __rest(_a, ["children", "selected", "size"]);
    return (React.createElement(Stack, Object.assign({ borderRadius: RadiusPixel.round, bgcolor: (theme) => theme.palette.common.white, padding: Spacing.xsmall, sx: { cursor: 'pointer' } }, props),
        React.createElement(Stack, { width: size, height: size, bgcolor: (theme) => theme.palette.buttonBrandSecondary.contained.default.backgroundColor, border: (theme) => `solid 2px ${selected
                ? theme.palette.common.black
                : theme.palette.buttonBrandSecondary.contained.default.backgroundColor}`, borderRadius: RadiusPixel.round, justifyContent: "center", alignItems: "center" },
            React.createElement(Typography, { variant: "labelSmall" }, children))));
};
